import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { RichSelectModule } from '@ag-grid-enterprise/rich-select';
import { ModuleRegistry } from '@ag-grid-community/core';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import CustomLoadingOverlay from '../../shared/component/customLoadingOverlay';
import Loader from '../../shared/component/Loader';
import ticket from '../../../src/assets/img/crm_home/header/ticket.png';
import {
  getLeadList,
  getLeadPageLoader,
  getleadTotalCount,
  getTagsByModule,
  getUser,
  getGridDataByModuleKey,
  getGenericMasterFilteredListByKey,
  getActiveOwners,
  getCampaignDropdownLead,
} from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataAndUpdateStore, fetchSelectedListAndAppendToModule } from '../../redux/actions';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import Select from 'react-select';
import schedule from '../../assets/img/leadsform/schedule.svg';
import {
  dropdownPayload,
  dropdownPayloadCampaignLead,
  filterParams,
  leadInputData,
  ticketInputData,
  // filterParams,
} from '../../shared/constants';
import MassEmail from './massEmail';
import Tags from '../sharedChild/tags';
import SelectBox from '../../shared/controls/form/selectBox';
import { validationSchemaLead } from './validationSchema';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import ChildTicket from '../sharedChild/childTicket';
import { updateGridColumnState } from '../../redux/reducer';
import {
  getCommonTextFilterParams,
  getSetDatefilterParams,
  getSetFilterParams,
  getSetCheckboxFilterParams,
} from '../../utils/agGridFilters';
import useLeadColumnDefs from './useLeadColumnDefs';
import { columnTypes } from '../../shared/initials';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  RangeSelectionModule,
  RowGroupingModule,
  RichSelectModule,
]);

// const OptionButton = ({
//   handleOpenEditForm,
//   paramsValue,
//   handleOpenViewForm,
//   handleClickOpenConvertLead,
//   rowData,
//   handleClickDelete,
//   emailPopup,
//   hasDeleteLeadPermission,
//   hasUpdateLeadPermission,
//   hasInfoLeadPermission,
// }) => {
//   const [isHover, setHover] = useState(false);
//   const [showConfirmation, setShowConfirmation] = useState(false);
//   const handleDeleteClick = (e) => {
//     e.preventDefault();
//     setShowConfirmation(true);
//   };

//   const handleConfirmDelete = () => {
//     console.log("rowData==>", rowData);
//     handleClickDelete(rowData);
//     setShowConfirmation(false);
//   };

//   const handleCloseConfirmation = () => {
//     setShowConfirmation(false);
//   };
//   return (
//     <div className="action-menu ">
//       {hasUpdateLeadPermission && (
//         <img
//           src="/assets/images/edit.png"
//           className="action-img1"
//           onClick={handleOpenEditForm}
//           alt="Edit Lead"
//           title="Edit Lead"
//         />
//       )}
//       {hasInfoLeadPermission && (
//         <img
//           src="/assets/images/view.png"
//           className="action-img2"
//           onClick={handleOpenViewForm}
//           alt="View Lead"
//           title="View Lead"
//         />
//       )}
//       <div className="dropdown">
//         <span
//           className="dropdown-toggle"
//           data-bs-toggle="dropdown"
//           aria-expanded="false"
//         >
//           <img
//             src="/assets/images/crm/leads/actiondot.svg"
//             className="action-img1 dropdown-toggle"
//             width="18px"
//             alt="More"
//             title="More"
//           />
//         </span>

//         <ul className="dropdown-menu">
//           {hasUpdateLeadPermission && (
//             <li className="dropdown-item">
//               <Link to="/leads/editLead" state={rowData}>
//                 Edit
//               </Link>
//             </li>
//           )}
//           <li className="dropdown-item">
//             <Link to="/leads/convertLead" state={rowData}>
//               Convert
//             </Link>
//           </li>
//           {hasDeleteLeadPermission && (
//             <li className="dropdown-item">
//               <Link onClick={handleDeleteClick}>Delete</Link>
//               <DeleteConfirmationModal
//                 show={showConfirmation}
//                 handleClose={handleCloseConfirmation}
//                 handleConfirm={handleConfirmDelete}
//                 content={"lead"}
//               />
//             </li>
//           )}

//         </ul>
//       </div>
//     </div>
//   );
// };

const Leads = () => {
  const stateData = useSelector((state) => state);
  const leadTotalCount = useSelector(getleadTotalCount);
  const leadPageLoader = useSelector(getLeadPageLoader);
  const [paginationLoading, setpaginationLoading] = useState(leadPageLoader);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(
    stateData,
    'leads',
    'tags',
    'campaignDropdownLead',
    'genericMasterFilteredList'
  );
  const [isTabActive, setIsTabActive] = useState('allLeads');
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedBucket, setSelectedBucket] = useState(null);
  const [filterJson, setfilterJson] = useState();
  const rowData = useSelector(getLeadList);
  const campaignListDropdown = useSelector(getCampaignDropdownLead);

  useFetchIfNeeded(getCampaignDropdownLead, fetchDataAndUpdateStore, {
    key: 'campaignDropdownLead',
    inputData: dropdownPayloadCampaignLead,
  });

  useFetchIfNeeded(getLeadList, fetchDataAndUpdateStore, {
    key: 'leads',
    inputData: leadInputData,
  });
  useFetchIfNeeded(getTagsByModule('leads'), fetchDataAndUpdateStore, {
    key: 'tagsByModule',
    inputData: 'Lead',
    storeKey: 'leads',
  });
  const {
    options: campaignList,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
    pageSize: 2000, // override default pageSize here
    module: 'Lead',
  });
  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));
  const userInfo = useSelector(getUser);
  const gridRef = useRef(); // Optional - for accessing Grid's
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [loading, setLoading] = useState(storeLoading);
  const [allcolumnList, setAllcolumnList] = useState([]);
  const [gridLoading, setGridLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState(false);
  const [isSelectedOption, setIsSelectedOption] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [fieldValues, setFieldValues] = useState({});
  const [ownerFieldValues, setOwnerFieldValues] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [campaignData, setcampaignData] = useState([]);
  const [showMassEmailPopup, setMassEmailPopup] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const gridData = useSelector(getGridDataByModuleKey('leads'));
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const [gridParams, setGridParams] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showWithAnimation, setShowWithAnimation] = useState(false);
  const [remindVisible, setRemindVisible] = useState(false);
  const [showReminderPage, setShowReminderPage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pendingEvent, setPendingEvent] = useState(null); // hold AG Grid event
  const [showExistingCampaignPopup, setShowExistingCampaignPopup] = useState(false);
  const gridOptions = gridOptionsConfig('leads', navigate);
  let hasUpdateLeadPermission = true;
  let hasCreateLeadPermission = true;
  let hasDeleteLeadPermission = true;
  let hasInfoLeadPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.leadmenu;

  if (userUIControlPermission) {
    hasCreateLeadPermission = userUIControlPermission?.leadaddscreen
      ? userUIControlPermission.leadaddscreen.canView
      : true;

    hasUpdateLeadPermission = userUIControlPermission?.leadupdatescreen
      ? userUIControlPermission.leadupdatescreen.canView
      : true;

    hasDeleteLeadPermission = userUIControlPermission?.leaddeletescreen
      ? userUIControlPermission.leaddeletescreen.canView
      : true;

    hasInfoLeadPermission = userUIControlPermission?.leadinfoscreen
      ? userUIControlPermission.leadinfoscreen.canView
      : true;
  }

  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );
  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));
  const owner = useSelector(getActiveOwners);
  const revenueTypeDropdown = useSelector(getGenericMasterFilteredListByKey('RevenueType'));
  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));
  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));
  const timeZoneList = useSelector(getGenericMasterFilteredListByKey('TimeZone'));

  const tagsList = useSelector(getTagsByModule('leads'));

  const handleOpenExistingCampaignPopup = () => {
    // Check if any selected row lacks an email
    const hasMissingEmail = selectedRows.some((row) => !row.email);

    if (hasMissingEmail) {
      toast.error('One of the selected lead does not have email');
      return;
    }

    // // Check if any selected row has opted out of emails
    const hasEmailOptOut = selectedRows.some((row) => row.emailOptOut);

    if (hasEmailOptOut) {
      toast.error('One of the selected lead has opted out of emails');
      return;
    }

    // Only open popup if all validations pass
    setShowExistingCampaignPopup(true);
  };

  const handleCloseExistingCampaignPopup = () => {
    setShowExistingCampaignPopup(false);
  };

  const closeMassEmailPopup = () => {
    setMassEmailPopup(false);
  };

  // const handleClickOpenConvertLead = (paramsValue) => {
  //   navigate("/leads/convertLead", {
  //     state: paramsValue,
  //   });
  // };

  const onSelectionChanged = (event) => {
    if (suppressSelectionChangeRef.current) {
      return; // skip handling if we just restored
    }

    const gridApi = gridRef.current.api;
    const selectedRowsLocal = gridApi.getSelectedRows();
    const key = 'page-' + gridData?.inputPayload?.pageNumber;

    setSelectedRows(selectedRowsLocal);

    dispatch(
      fetchSelectedListAndAppendToModule({
        key: 'leads',
        selectedList: { [key]: selectedRowsLocal },
      })
    );
  };

  const fullSelection = Object.values(gridDataSelection?.leads || {}).flat();

  console.log('🚀 ~ Leads ~ gridDataSelection:', gridDataSelection);

  const handleOpenMassEmail = () => {
    navigate('/leads/massEmailPage', { state: { module: 'Lead' } });
  };
  const handleOpenManageTag = () => {
    navigate('/leads/manageTags', {
      state: { module: 'leads', moduleApi: 'Lead' },
    });
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const emailPopup = () => {
    setIsOpen(!isOpen);
    if (isMinimized) setIsMinimized(false); // Reset minimized state if reopening
  };
  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    let data;
    // Creating the desired JSON object
    if (paramsValue.id === undefined) {
      const selectedIds = fullSelection.map((row) => row.id);
      data = { id: selectedIds };
    } else {
      data = {
        id: [paramsValue.id],
      };
    }
    console.log('Data==>>', data);
    apiServices.deleteLead(data).then((response) => {
      if (response.status === 200) {
        toast.success('Lead Deleted Successfully!', {
          position: 'top-right',
        });
        if (paramsValue.id === undefined) {
          document.getElementById('massDeleteModal').click();
        }
        dispatch(
          fetchSelectedListAndAppendToModule({
            key: 'leads',
            selectedList: {},
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'leads',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : leadInputData,
          })
        );

        console.log(gridData?.selectedList);
        dispatch(
          fetchDataAndUpdateStore({
            key: 'leadDropdown',
            inputData: dropdownPayload,
          })
        );
        setLoading(false);
      }
    });
  };
  // const [columnDefs, setColumnDefs] = useState([]);

  const columnDefs = useLeadColumnDefs({
    hasUpdateLeadPermission,
    hasInfoLeadPermission,
    hasDeleteLeadPermission,
    gridData,
    handleClickDelete,
    emailPopup,
    leadSourceDropdown,
    industryTypeDropdown,
    campaignListDropdown,
    tagsList,
    salutation,
    revenueTypeDropdown,
    timeZoneList,
    owner,
  });
  // useEffect(() => {
  //   const isDropdownsReady =
  //     leadSourceDropdown?.length &&
  //     industryTypeDropdown?.length &&
  //     campaignListDropdown?.length &&
  //     tagsList?.length &&
  //     salutation?.length &&
  //     revenueTypeDropdown?.length &&
  //     timeZoneList?.length;

  //   if (!isDropdownsReady) return;

  //   const actionCol =
  //     (hasUpdateLeadPermission || hasInfoLeadPermission || hasDeleteLeadPermission) && {
  //       headerName: "Actions",
  //       headerCheckboxSelection: true,
  //       headerCheckboxSelectionFilteredOnly: true,
  //       checkboxSelection: true,
  //       cellRenderer: (params) => {
  //         const rowData = { ...params.data };
  //         return (
  //           <OptionButton
  //             rowData={rowData}
  //             hasInfoLeadPermission={hasInfoLeadPermission}
  //             hasDeleteLeadPermission={hasDeleteLeadPermission}
  //             hasUpdateLeadPermission={hasUpdateLeadPermission}
  //             handleOpenEditForm={() => handleOpenEditForm(rowData)}
  //             handleOpenViewForm={() => handleOpenViewForm(rowData)}
  //             handleClickOpenConvertLead={() => handleClickOpenConvertLead(rowData)}
  //             handleClickDelete={() => handleClickDelete(rowData)}
  //             emailPopup={() => emailPopup(rowData)}
  //           />
  //         );
  //       },
  //       maxWidth: 100,
  //       minWidth: 100,
  //       sortable: false,
  //       filter: false,
  //       pinned: "left"
  //     };

  //   const columns = [
  //     ...(actionCol ? [actionCol] : []),
  //     {
  //       headerName: "Full Name",
  //       field: "fullName",
  //       cellRenderer: (params) =>
  //         !params.value || params.node.group ? (
  //           params.value
  //         ) : hasInfoLeadPermission ? (
  //           <Link
  //             to={`/leads/viewLead?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
  //             state={params.data}
  //             style={{ fontWeight: "600" }}
  //           >
  //             {params.value}
  //           </Link>
  //         ) : (
  //           <span style={{ fontWeight: "600" }}>{params.value}</span>
  //         ),
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       minWidth: 180
  //     },
  //     {
  //       headerName: "Tags",
  //       field: "tagIds",
  //       valueGetter: (params) => params.data.tags,
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(tagsList?.map((item) => item?.name[0])),
  //       // hide: true
  //     },
  //     {
  //       headerName: "Company Name",
  //       field: "companyName",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       minWidth: 200,
  //       pinned: isMobile() ? null : "left"
  //     },
  //     {
  //       headerName: "Email",
  //       field: "email",
  //       filter: "agTextColumnFilter",
  //       type: "text",
  //       cellRenderer: EmailCellRenderer,
  //       filterParams: commonTextFilterParams
  //     },
  //     {
  //       headerName: "Phone",
  //       field: "phone",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams
  //     },
  //     {
  //       headerName: "Lead Source",
  //       field: "leadSource",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(leadSourceDropdown.map((item) => item.displayName))
  //     },
  //     {
  //       headerName: "Lead Owner",
  //       field: "owner",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(owner?.map((item) => item.display_name))
  //     },
  //     {
  //       headerName: "Campaign Name",
  //       field: "campaignId",
  //       valueGetter: (params) => params.data?.campaignName || "",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(campaignListDropdown?.map((item) => item.campaignName)),
  //       // hide: true,
  //       suppressColumnsToolPanel: true
  //     },
  //     {
  //       headerName: "Industry",
  //       field: "industry",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(industryTypeDropdown?.map((item) => item.displayName))
  //     },
  //     {
  //       headerName: "Business Type",
  //       field: "businessType",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams
  //     },
  //     {
  //       headerName: "Line of Business",
  //       field: "lineOfBusiness",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams
  //     },
  //     {
  //       headerName: "Contact LinkedIn",
  //       field: "contactLinkedIn",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       cellRenderer: (params) =>
  //         params.value ? (
  //           <a
  //             href={params.value.startsWith("http") ? params.value : `https://${params.value}`}
  //             target="_blank"
  //             rel="noopener noreferrer"
  //           >
  //             {params.value}
  //           </a>
  //         ) : null,
  //       filterParams: commonTextFilterParams
  //     },
  //     {
  //       headerName: "Time Zone",
  //       field: "timeZone",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(timeZoneList?.map((item) => item.displayName))
  //     },
  //     {
  //       headerName: "Created By",
  //       field: "createdBy",
  //       valueFormatter: NameFormatter,
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       minWidth: 180
  //     },
  //     {
  //       headerName: "Updated By",
  //       field: "updatedBy",
  //       valueFormatter: NameFormatter,
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       minWidth: 180
  //     },
  //     {
  //       headerName: "Created Date Time (UTC)",
  //       field: "createdDateTime",
  //       valueFormatter: DateTimeFormatter,
  //       filter: "agDateColumnFilter",
  //       filterParams: dateFilterParams,
  //       minWidth: 230,
  //       // hide: true
  //     },
  //     {
  //       headerName: "Updated Date Time (UTC)",
  //       field: "updatedDateTime",
  //       valueFormatter: DateTimeFormatter,
  //       filter: "agDateColumnFilter",
  //       filterParams: dateFilterParams,
  //       minWidth: 230,
  //       // hide: true
  //     },
  //     {
  //       headerName: "Company LinkedIn",
  //       field: "companyLinkedIn",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       cellRenderer: (params) => {
  //         if (!params.value) return null; // Return null if the value is empty or undefined

  //         const url = params.value.startsWith("http")
  //           ? params.value
  //           : `https://${params.value}`;
  //         return (
  //           <a href={url} target="_blank" rel="noopener noreferrer">
  //             {params.value}
  //           </a>
  //         );
  //       },
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Website",
  //       field: "website",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       cellRenderer: (params) => {
  //         if (!params.value) return null; // Return null if the value is empty or undefined

  //         // Ensure URL has protocol for the link
  //         const url = params.value.startsWith("http")
  //           ? params.value
  //           : `https://${params.value}`;

  //         return (
  //           <a href={url} target="_blank" rel="noopener noreferrer">
  //             {params.value}
  //           </a>
  //         );
  //       },
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Annual Revenue",
  //       field: "annualRevenue",
  //       type: "text",
  //       filter: "agNumberColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       valueFormatter: currencyFormatterByField("annualRevenue"),
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Written Premium",
  //       field: "writtenPremium",
  //       type: "text",
  //       filter: "agNumberColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       valueFormatter: currencyFormatterByField("writtenPremium"),
  //       // hide: true,
  //     },
  //     {
  //       headerName: "No. of Employees",
  //       field: "noOfEmployees",
  //       type: "number",
  //       filter: "agNumberColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "No. of Beds",
  //       field: "noOfBeds",
  //       type: "number",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Source Name",
  //       field: "sourceName",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Other Source Name",
  //       field: "otherSourceName",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Salutation",
  //       field: "salutation",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(
  //         salutation?.map((item) => item.displayName)
  //       ),
  //       // hide: true,
  //     },
  //     {
  //       headerName: "First Name",
  //       field: "firstName",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Middle Name",
  //       field: "middleName",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Last Name",
  //       field: "lastName",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Revenue Type",
  //       field: "revenueType",
  //       type: "dropdown",
  //       filter: "agSetColumnFilter",
  //       filterParams: filterParams(
  //         revenueTypeDropdown?.map((item) => item.displayName)
  //       ),
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Title",
  //       field: "title",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Secondary Email",
  //       field: "secondaryEmail",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       cellRenderer: (params) => {
  //         if (!params.value) return null; // Return null if the value is empty or undefined

  //         return <a href={`mailto:${params.value}`}>{params.value}</a>;
  //       },
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Mobile",
  //       field: "mobile",
  //       type: "number",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Direct Phone",
  //       field: "directPhone",
  //       type: "number",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Alternate Phone",
  //       field: "alternatePhone",
  //       type: "number",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Street",
  //       field: "street",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "City",
  //       field: "city",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Email Opt Out",
  //       field: "emailOptOut",
  //       filter: "agSetColumnFilter",
  //       type: "checkbox",
  //       filterParams: checkboxFilterParams,
  //       // hide: true,
  //     },

  //     {
  //       headerName: "State",
  //       field: "state",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Zip Code",
  //       field: "zipCode",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Country",
  //       field: "country",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Description",
  //       field: "description",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     },
  //     {
  //       headerName: "Technology Details",
  //       field: "technologyDetails",
  //       type: "text",
  //       filter: "agTextColumnFilter",
  //       filterParams: commonTextFilterParams,
  //       // hide: true,
  //     }
  //   ];

  //   setColumnDefs(columns);
  // }, [
  //   leadSourceDropdown,
  //   industryTypeDropdown,
  //   campaignListDropdown,
  //   tagsList,
  //   salutation,
  //   revenueTypeDropdown,
  //   timeZoneList,
  //   owner
  // ]);
  // useEffect(() => {
  //   // setLoading(true)
  //   if (
  //     leadSourceDropdown?.length > 0 &&
  //     industryTypeDropdown?.length > 0 &&
  //     campaignListDropdown?.length > 0 &&
  //     tagsList?.length > 0 &&
  //     industryTypeDropdown?.length > 0 &&
  //     salutation?.length > 0 &&
  //     revenueTypeDropdown?.length > 0 &&
  //     timeZoneList?.length > 0
  //   ) {
  //     setColumnDefs([
  //       (hasUpdateLeadPermission ||
  //         hasInfoLeadPermission ||
  //         hasDeleteLeadPermission) &&

  //       {
  //         headerName: "Actions",
  //         headerCheckboxSelection: true,
  //         headerCheckboxSelectionFilteredOnly: true,
  //         checkboxSelection: true,

  //         cellRenderer: (params) => {
  //           const paramsValue = { ...params.data };
  //           return (
  //             <OptionButton
  //               rowData={paramsValue}
  //               // openPopup={open}
  //               hasInfoLeadPermission={hasInfoLeadPermission}
  //               hasDeleteLeadPermission={hasDeleteLeadPermission}
  //               hasUpdateLeadPermission={hasUpdateLeadPermission}
  //               handleOpenEditForm={() => handleOpenEditForm(paramsValue)}
  //               handleOpenViewForm={() => handleOpenViewForm(paramsValue)}
  //               handleClickOpenConvertLead={() =>
  //                 handleClickOpenConvertLead(paramsValue)
  //               }
  //               handleClickDelete={() => handleClickDelete(paramsValue)}
  //               emailPopup={() => emailPopup(paramsValue)}
  //             />
  //           );
  //         },
  //         maxWidth: 100,
  //         minWidth: 100,
  //         sortable: false,
  //         filter: false,
  //         pinned: "left",

  //       },
  //       {
  //         headerName: "Full Name",
  //         field: "fullName",
  //         cellRenderer: (params) => {
  //           if (!params.value || params.node.group) return params.value;

  //           // Conditionally make the name clickable if permission exists
  //           return hasInfoLeadPermission ? (
  //             <Link
  //               to={`/leads/viewLead?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
  //               state={params.data}
  //               style={{ fontWeight: "600" }}
  //             >
  //               {params.value}
  //             </Link>
  //           ) : (
  //             <span style={{ fontWeight: "600" }}>{params.value}</span>
  //           );
  //         },
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,

  //         // pinned: isMobile() ? null : "left",
  //         minWidth: 180,

  //       },
  //       {
  //         headerName: "Tags",
  //         field: "tagIds",
  //         valueGetter: (params) => params.data.tags,
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     tagsList && tagsList.length > 0
  //         //       ? tagsList.map((item) => item?.name[0])
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           tagsList?.map((item) => item?.name[0])
  //         ),
  //         hide: true,
  //       },
  //       {
  //         headerName: "Company Name",
  //         field: "companyName",
  //         filter: "agTextColumnFilter",
  //         type: "text",
  //         lockPosition: "Left",
  //         filterParams: commonTextFilterParams,
  //         minWidth: 200,
  //         pinned: isMobile() ? null : "left",
  //       },
  //       // {
  //       //   headerName: "Email",
  //       //   field: "email",
  //       //   filter: "agTextColumnFilter",
  //       //   type: "text",
  //       //   cellRenderer: (params) => {
  //       //     if (!params.value) return null; // Return null if the value is empty or undefined

  //       //     return <a href={`mailto:${params.value}`}>{params.value}</a>;
  //       //   },
  //       //   filterParams: commonTextFilterParams,
  //       // },
  //       {
  //         headerName: "Email",
  //         field: "email",
  //         filter: "agTextColumnFilter",
  //         type: "text",
  //         cellRenderer: EmailCellRenderer,
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Phone",
  //         field: "phone",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Lead Source",
  //         field: "leadSource",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         filterParams: filterParams(
  //           leadSourceDropdown?.map((item) => item.displayName)
  //         )//,
  //         // filterParams: {
  //         //   values:
  //         //     leadSourceDropdown && leadSourceDropdown.length > 0
  //         //       ? leadSourceDropdown.map((item) => item.displayName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //       },
  //       {
  //         headerName: "Lead Owner",
  //         field: "owner",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     owner && owner.length > 0
  //         //       ? owner.map((item) => item.display_name)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           owner?.map((item) => item.display_name)
  //         )
  //       },
  //       {
  //         headerName: "Campaign Name",
  //         field: "campaignId", // Field used for filtering (id)
  //         valueGetter: (params) => params.data?.campaignName || "", // Show campaignName in table
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     campaignListDropdown && campaignListDropdown.length > 0
  //         //       ? campaignListDropdown.map((item) => item.campaignName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           campaignListDropdown?.map((item) => item.campaignName)
  //         ),
  //         hide: true, // Show column for testing
  //         suppressColumnsToolPanel: true,
  //       },

  //       {
  //         headerName: "Industry",
  //         field: "industry",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     industryTypeDropdown && industryTypeDropdown.length > 0
  //         //       ? industryTypeDropdown.map((item) => item.displayName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           industryTypeDropdown?.map((item) => item.displayName)
  //         )
  //       },
  //       {
  //         headerName: "Business Type",
  //         field: "businessType",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Line of Business",
  //         field: "lineOfBusiness",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Contact LinkedIn",
  //         field: "contactLinkedIn",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         cellRenderer: (params) => {
  //           if (!params.value) return null; // Return null if the value is empty or undefined

  //           const url = params.value.startsWith("http")
  //             ? params.value
  //             : `https://${params.value}`;
  //           return (
  //             <a href={url} target="_blank" rel="noopener noreferrer">
  //               {params.value}
  //             </a>
  //           );
  //         },
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Time Zone",
  //         field: "timeZone",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     timeZoneList && timeZoneList.length > 0
  //         //       ? timeZoneList.map((item) => item.displayName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           timeZoneList?.map((item) => item.displayName)
  //         )
  //       },
  //       {
  //         headerName: "Created By",
  //         field: "createdBy",
  //         minWidth: 180,
  //         valueFormatter: NameFormatter,
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Updated By",
  //         field: "updatedBy",
  //         minWidth: 180,
  //         valueFormatter: NameFormatter,
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //       },
  //       {
  //         headerName: "Created Date Time(UTC)",
  //         field: "createdDateTime",
  //         valueFormatter: DateTimeFormatter,
  //         minWidth: 230,
  //         filter: "agDateColumnFilter",
  //         filterParams: dateFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Updated Date Time(UTC)",
  //         field: "updatedDateTime",
  //         minWidth: 230,
  //         valueFormatter: DateTimeFormatter,
  //         filter: "agDateColumnFilter",
  //         filterParams: dateFilterParams,
  //         hide: true,
  //       },

  //       {
  //         headerName: "Company LinkedIn",
  //         field: "companyLinkedIn",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         cellRenderer: (params) => {
  //           if (!params.value) return null; // Return null if the value is empty or undefined

  //           const url = params.value.startsWith("http")
  //             ? params.value
  //             : `https://${params.value}`;
  //           return (
  //             <a href={url} target="_blank" rel="noopener noreferrer">
  //               {params.value}
  //             </a>
  //           );
  //         },
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Website",
  //         field: "website",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         cellRenderer: (params) => {
  //           if (!params.value) return null; // Return null if the value is empty or undefined

  //           // Ensure URL has protocol for the link
  //           const url = params.value.startsWith("http")
  //             ? params.value
  //             : `https://${params.value}`;

  //           return (
  //             <a href={url} target="_blank" rel="noopener noreferrer">
  //               {params.value}
  //             </a>
  //           );
  //         },
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Annual Revenue",
  //         field: "annualRevenue",
  //         type: "text",
  //         filter: "agNumberColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         valueFormatter: currencyFormatterByField("annualRevenue"),
  //         hide: true,
  //       },
  //       {
  //         headerName: "Written Premium",
  //         field: "writtenPremium",
  //         type: "text",
  //         filter: "agNumberColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         valueFormatter: currencyFormatterByField("writtenPremium"),
  //         hide: true,
  //       },
  //       {
  //         headerName: "No. of Employees",
  //         field: "noOfEmployees",
  //         type: "number",
  //         filter: "agNumberColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "No. of Beds",
  //         field: "noOfBeds",
  //         type: "number",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Source Name",
  //         field: "sourceName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Other Source Name",
  //         field: "otherSourceName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Salutation",
  //         field: "salutation",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     salutation && salutation.length > 0
  //         //       ? salutation.map((item) => item.displayName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           salutation?.map((item) => item.displayName)
  //         ),
  //         hide: true,
  //       },
  //       {
  //         headerName: "First Name",
  //         field: "firstName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Middle Name",
  //         field: "middleName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Last Name",
  //         field: "lastName",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Revenue Type",
  //         field: "revenueType",
  //         type: "dropdown",
  //         filter: "agSetColumnFilter",
  //         // filterParams: {
  //         //   values:
  //         //     revenueTypeDropdown && revenueTypeDropdown.length > 0
  //         //       ? revenueTypeDropdown.map((item) => item.displayName)
  //         //       : [],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true, // ✅ Unchecks all records by default
  //         //   applyButtonDisabled: (params) =>
  //         //     params.filterModel.values.length === 0,
  //         // },
  //         filterParams: filterParams(
  //           revenueTypeDropdown?.map((item) => item.displayName)
  //         ),
  //         hide: true,
  //       },
  //       {
  //         headerName: "Title",
  //         field: "title",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Secondary Email",
  //         field: "secondaryEmail",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         cellRenderer: (params) => {
  //           if (!params.value) return null; // Return null if the value is empty or undefined

  //           return <a href={`mailto:${params.value}`}>{params.value}</a>;
  //         },
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Mobile",
  //         field: "mobile",
  //         type: "number",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Direct Phone",
  //         field: "directPhone",
  //         type: "number",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Alternate Phone",
  //         field: "alternatePhone",
  //         type: "number",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Street",
  //         field: "street",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "City",
  //         field: "city",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Email Opt Out",
  //         field: "emailOptOut",
  //         filter: "agSetColumnFilter",
  //         type: "checkbox",
  //         // filterParams: {
  //         //   values: [true, false],
  //         //   buttons: ["apply", "reset"],
  //         //   closeOnApply: true,
  //         //   defaultToNothingSelected: true,
  //         //   suppressSyncValuesAfterDataChange: true,
  //         //   refreshValuesOnOpen: false,
  //         //   applyButtonDisabled: (params) =>
  //         //     !params.filterModel?.values?.length,
  //         // },
  //         filterParams: checkboxFilterParams,
  //         hide: true,
  //       },

  //       {
  //         headerName: "State",
  //         field: "state",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Zip Code",
  //         field: "zipCode",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Country",
  //         field: "country",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Description",
  //         field: "description",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //       {
  //         headerName: "Technology Details",
  //         field: "technologyDetails",
  //         type: "text",
  //         filter: "agTextColumnFilter",
  //         filterParams: commonTextFilterParams,
  //         hide: true,
  //       },
  //     ]);
  //   }
  // }, [
  //   leadSourceDropdown,
  //   industryTypeDropdown,
  //   campaignListDropdown,
  //   timeZoneList,
  //   revenueTypeDropdown,
  //   loading,
  //   tagsList,
  // ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    // movable: true
  }));

  const CustomTotalRowCountComponent = () => {
    return (
      <div className="ag-status-name-value">
        {leadTotalCount === undefined ? (
          <></>
        ) : (
          <>
            <span className="component">Total Rows: &nbsp;</span>
            <span className="ag-status-name-value-value">{leadTotalCount}</span>
          </>
        )}
      </div>
    );
  };

  const PaginationLoadingComponent = () => {
    return (
      <div className="ag-status-name-value loading">
        {paginationLoading ? <span className="component">Loading... &nbsp;</span> : <span></span>}
      </div>
    );
  };
  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: PaginationLoadingComponent, align: 'center' },
        { statusPanel: CustomTotalRowCountComponent, align: 'right' },
        { statusPanel: 'agFilteredRowCountComponent' },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  }, [leadTotalCount, paginationLoading]);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);
  const cellClickedListener = useCallback((event) => { }, []);
  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
    getAllColumns();
  }, []);

  const exportAll = async () => {
    setLoading(true);

    // Ensure filterJson is considered
    const fetchData = {
      ...leadInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllLead(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        // const responseText = typeof response.data === "string" ? response.data.trim() : "";

        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Leads.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting leads:', error);
      setLoading(false);
    }
  };

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  // const handleOpenEditForm = (paramsValue) => {
  //   navigate("/leads/editLead", {
  //     state: paramsValue,
  //   });
  // };

  // const handleOpenViewForm = (paramsValue) => {
  //   navigate(`/leads/viewLead?id=${paramsValue.id}&pageNo=${gridData?.inputPayload?.pageNumber}`, {
  //     state: paramsValue,
  //   });
  // };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    navigate('/leads/CreateNew');
  };
  const [showPopup, setShowPopup] = useState(false);

  const [popupAction, setPopupAction] = useState('add');

  // When "Add Tags" is clicked, set mode to "add" and show the popup
  const handleAddTag = () => {
    setPopupAction('add');
    setShowPopup(true);
  };

  // When "Remove Tags" is clicked, set mode to "remove" and show the popup
  const handleRemoveTag = () => {
    setPopupAction('remove');
    setShowPopup(true);
  };

  // Toggle the popup visibility
  const togglePopup = () => {
    setShowPopup((prev) => !prev);
  };

  const togglePopupVisibility = () => {
    setRemindVisible(!remindVisible);
    setShowReminderPage(false); // Reset to default page on close
  };

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...campaignData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setcampaignData({
        ...campaignData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    } else if (name === 'campaignId') {
      setcampaignData({
        ...campaignData,
        campaignId: selectedId,
      });
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'priorityId') {
      setFormData({
        ...formData,
        priorityId: selectedId,
        priority: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    }
  };

  const handleSubmit = async (campaignData) => {
    setLoading(true);
    const selectedIds = fullSelection.map((row) => row.id);

    const updatedFormData = {
      ...campaignData,
      campaignId: [campaignData.campaignId],
      leadId: selectedIds,
    };
    apiServices
      .addCampaignFromLead(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          setShowExistingCampaignPopup(false);
          if (response?.data === 'No new records inserted (duplicates exist)') {
            toast.error('No new records inserted (duplicates exist)', {
              position: 'top-right',
            });
            setLoading(false);
          } else {
            setLoading(false);
            toast.success('Campaign Added successfully!', {
              position: 'top-right',
            });
          }
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),

    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none', // Hide the dropdown arrow
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  // Method to get all columns
  const getAllColumns = () => {
    const columnApi = gridRef.current.columnApi;
    const data = columnApi.api.getAllGridColumns();
    const excludedColumns = [
      'Company Name',
      'Phone',
      'Alternate Phone',
      'Time Zone',
      'Company LinkedIn',
      'Website',
      'Annual Revenue',
      'Written Premium',
      'Revenue Type',
      'No. of Employees',
      'No. of Beds',
      'Business Type',
      'Industry',
      'Line of Business',
      'Lead Source',
      'Source Name',
      'Other Source Name',
      'Lead Owner',
      'Salutation',
      'First Name',
      'Middle Name',
      'Last Name',
      'Title',
      'Email',
      'Secondary Email',
      'Direct Phone',
      'Mobile',
      'Contact LinkedIn',
      'Email Opt Out',
      'Street',
      'City',
      'State',
      'Zip Code',
      'Country',
      'Description',
      'Technology Details',
    ];
    const allColumns = data
      .map((col) => col.getColDef())
      .filter((colDef) => excludedColumns.includes(colDef.headerName));
    setAllcolumnList(allColumns);
    console.log('All Columns:', allColumns);
  };

  const handleGetMassPopup = () => {
    getAllColumns();
    setFieldValues({});
    setOwnerFieldValues((prevValues) => ({
      ...prevValues,
      ownerId: userInfo?.user?.userId,
    }));
    setIsSelectedOption(false);
    setSelectedOptions(null);
  };

  const handleSelection = (selectedOption) => {
    setIsSelectedOption(true);
    setFieldValues({});

    const { headerName } = selectedOption?.originalData || {};

    // Show validation toast if "No of Beds" is selected but industry ≠ "Healthcare"
    if (
      headerName === 'No. of Beds' &&
      fullSelection.some((row) => row.industry?.toLowerCase() !== 'healthcare')
    ) {
      toast.error("Selected rows do not have industry 'Healthcare'");
      return;
    }

    // Mapping of headerName to corresponding data source
    const headerDataMap = {
      'Lead Source': leadSourceDropdown,
      'Lead Owner': owner,
      Industry: industryTypeDropdown,
      'Time Zone': timeZoneList,
      Salutation: salutation,
      'Revenue Type': revenueTypeDropdown,
    };

    if (headerDataMap[headerName]) {
      selectedOption.originalData.data = headerDataMap[headerName];
    }

    if (headerName === 'Email Opt Out') {
      setFieldValues((prev) => ({
        ...prev,
        emailOptOut: false,
      }));
    }

    setSelectedOption(selectedOption);
    console.log('Selected Option:', selectedOption);
  };

  const handleInputChange = (e, fieldName) => {
    const value = e.target.value;
    // For other fields, directly update the state
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value

    setFieldValues((prevValues) => ({
      ...prevValues,
      [name]: checked, // Set the checkbox state as true/false
    }));
  };

  const updateList = (msg, filterJson = null) => {
    if (filterJson !== null) {
      setLoading(false);
      const columnName = 'UpdatedDateTime';
      const orderType = 'desc';
      const data = {
        ...(gridData?.inputPayload ? gridData?.inputPayload : leadInputData),
        pageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE),
        pageNumber: 1,
        filterJson: filterJson,
      };
      setfilterJson(data);
      dispatch(fetchDataAndUpdateStore({ key: 'leads', inputData: data }));
      navigate('/leads');
    } else {
      setLoading(false);
      if (msg)
        toast.success(msg, {
          position: 'top-right',
        });
      const columnName = 'UpdatedDateTime';
      const orderType = 'desc';
      dispatch(fetchDataAndUpdateStore({ key: 'leads', inputData: leadInputData }));
      navigate('/leads');
    }
  };

  const handleMassUpdate = async (selectedRowData) => {
    setLoading(true); // Set loading state when starting mass update
    let result;
    console.log('selectedRowData', selectedRowData);

    // Extract the IDs from the selectedRowData array
    const ids = selectedRowData.map((item) => item.id);

    // Check if there is at least one field to update
    if (Object.keys(fieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(fieldValues)[0];

      // Validate the specific field using Yup's validateAt
      try {
        await validationSchemaLead.validateAt(fieldName, {
          [fieldName]: fieldValue,
        });
      } catch (error) {
        if (error.name === 'ValidationError') {
          toast.error(`Validation error in ${fieldName}: ${error.message}`, {
            position: 'top-right',
          });
          setLoading(false); // Reset loading state on validation error
          return;
        }
      }

      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue.toString(),
      };
    } else {
      toast.error('No field values provided for update.', {
        position: 'top-right',
      });
      setLoading(false); // Reset loading state if no fields to update
      return;
    }

    console.log('result:', result);
    console.log('Submitted Values:', fieldValues);

    try {
      const response = await apiServices.updateMultipleLeadFields(result);
      if (response.status === 200) {
        document.getElementById('massUpdateCancel').click();
        toast.success('Lead Updated Successfully!', { position: 'top-right' });
        handleGetMassPopup();
        dispatch(
          fetchDataAndUpdateStore({
            key: 'leads',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : leadInputData,
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'leadDropdown',
            inputData: dropdownPayload,
          })
        );
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      toast.error('An unexpected error occurred.', { position: 'top-right' });
      setLoading(false);
    }
  };

  const handleDropdownChange = (selected, fieldName) => {
    const value = selected.value;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));

    console.log(`Dropdown selected: ${value}`);
  };

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      // Format the selected data as required
      const formattedData = {
        fieldName: 'ownerId', // Static field name
        fieldValue: selectedOption.value, // The `value` from the dropdown
      };

      setOwnerFieldValues((prevValues) => ({
        ...prevValues,
        [formattedData.fieldName]: formattedData.fieldValue,
      }));
    }
  };

  const handleOwnerUpdate = (selectedRowData) => {
    setLoading(true);
    let result;
    console.log('selectedRowData', selectedRowData);
    // Extract the IDs from the selectedRowData array
    const ids = selectedRowData.map((item) => item.id);
    if (Object.keys(ownerFieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(ownerFieldValues)[0];
      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue,
      };
    }
    apiServices
      .updateMultipleLeadFields(result)
      .then((response) => {
        if (response.status === 200) {
          document.getElementById('ownerUpdateCancel').click();
          toast.success('Owner Updated Successfully!', {
            position: 'top-right',
          });
          handleGetMassPopup();
          dispatch(
            fetchDataAndUpdateStore({
              key: 'leads',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : leadInputData,
            })
          );
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleReminderClick = () => {
    setShowReminderPage(!showReminderPage);
    // When turning off reminder, clear the reminder value
    if (showReminderPage) {
      setFormData({
        ...formData,
        reminder: null,
        showReminder: false,
      });
    } else {
      // When turning on, preserve existing reminder if any
      setFormData({
        ...formData,
        showReminder: true,
      });
    }
  };

  const handleBackClick = () => {
    setShowReminderPage(false);

    setFormData((prev) => ({
      ...prev,
      showReminder: !!prev.reminder, // true if reminder exists, false otherwise
    }));
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    const ids = fullSelection.map((item) => item.id);
    const updatedFormData = {
      ...formData,
      leadId: ids.toString(),
    };
    apiServices
      .createTicketList(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          togglePopupVisibility();
          toast.success('Ticket created successfully!');
          dispatch(
            fetchDataAndUpdateStore({
              key: 'ticketList',
              inputData: ticketInputData,
            })
          );
          setFormData([]);
          setSelectedOptions(null);
          setLoading(false);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleDateTime = (e) => {
    setFormData({
      ...formData,
      reminder: e.target.value,
      showReminder: true,
    });
  };

  const filterDefaultSetRef = useRef(null);

  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();
        console.log('Original Filter Model:', filterModel);

        // Create mappings for campaign names and tag names to their IDs
        const campaignMapping = {};
        if (campaignListDropdown?.length) {
          campaignListDropdown.forEach((item) => {
            campaignMapping[item.campaignName] = item.id;
          });
        }

        const tagMapping = {};
        if (tagsList?.length) {
          tagsList.forEach((item) => {
            tagMapping[item.name] = item.id;
          });
        }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];

          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => campaignMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          } else if (dynamicFilterKey === 'tagIds') {
            const idValues = filterData.values
              .map((name) => {
                if (name === '(Blanks)') return null; // Handle blanks
                return tagMapping[name];
              })
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Will include "" for blanks
                })),
              };
            }
          }

          // Keep Other Filters Unchanged
          else {
            acc[dynamicFilterKey] = filterData;
          }

          return acc;
        }, {});

        console.log('Updated Filter Model:', updatedFilterModel);

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        console.log('Filter Payload:', payload);

        dispatch(
          fetchDataAndUpdateStore({
            key: 'leads',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload, campaignListDropdown, tagsList]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'leads',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const handleColumnChanged = (params) => {
    const columnApi = gridRef.current.columnApi;
    const columnState = columnApi.getColumnState();
    dispatch(
      updateGridColumnState({
        moduleKey: 'leads',
        columnState: columnState,
      })
    );
  };

  const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;

    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = [
        'tagIds',
        'campaignId',
        'createdDateTime',
        'updatedDateTime',
        'companyLinkedIn',
        'website',
        'annualRevenue',
        'writtenPremium',
        'noOfEmployees',
        'noOfBeds',
        'sourceName',
        'otherSourceName',
        'salutation',
        'firstName',
        'middleName',
        'lastName',
        'revenueType',
        'title',
        'secondaryEmail',
        'mobile',
        'directPhone',
        'alternatePhone',
        'street',
        'city',
        'emailOptOut',
        'state',
        'zipCode',
        'country',
        'description',
        'technologyDetails',
      ];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };
  // useEffect(() => {
  //   if (
  //     gridRef.current?.api && gridData && !gridData?.columnState) {
  //      [
  //       'tagIds',
  //       'campaignId',
  //       'createdDateTime',
  //       'updatedDateTime',
  //       'companyLinkedIn',
  //       'website',
  //       'annualRevenue',
  //       'writtenPremium',
  //       'noOfEmployees',
  //       'noOfBeds',
  //       'sourceName',
  //       'otherSourceName',
  //       'salutation',
  //       'firstName',
  //       'middleName',
  //       'lastName',
  //       'revenueType',
  //       'title',
  //       'secondaryEmail',
  //       'mobile',
  //       'directPhone',
  //       'alternatePhone',
  //       'street',
  //       'city',
  //       'emailOptOut',
  //       'state',
  //       'zipCode',
  //       'country',
  //       'description',
  //       'technologyDetails'
  //     ].forEach(field => gridRef.current.api.setColumnVisible(field, false));
  //   }
  //   }, [gridRef, gridData]);

  const suppressSelectionChangeRef = useRef(false);

  const location = useLocation();

  useEffect(() => {
    if (
      gridRef.current?.api &&
      gridData?.leads?.length &&
      (campaignListDropdown?.length || tagsList?.length) &&
      gridData?.inputPayload?.filterJson
    ) {
      try {
        // Parse filterJson
        const filterJson = JSON.parse(gridData.inputPayload.filterJson);

        // Extract campaign IDs
        const campaignIds = filterJson?.campaignId?.conditions
          ? filterJson.campaignId.conditions.map((condition) => condition.filter)
          : filterJson?.campaignId?.filter
            ? [filterJson.campaignId.filter]
            : [];

        // Extract tag IDs
        const tagIds = filterJson?.tagIds?.conditions
          ? filterJson.tagIds.conditions.map((condition) => condition.filter)
          : filterJson?.tagIds?.filter
            ? [filterJson.tagIds.filter]
            : [];
        setfilterJson(filterJson);
        console.log('Extracted Campaign IDs:', campaignIds);
        console.log('Extracted Tag IDs:', tagIds);

        // Create a mapping of campaignId -> campaignName
        const campaignMapping = campaignListDropdown.reduce((acc, campaign) => {
          acc[campaign.id] = campaign.campaignName;
          return acc;
        }, {});

        // Create a mapping of tagId -> tagName
        const tagMapping = tagsList.reduce((acc, tag) => {
          acc[tag.id] = tag.name;
          return acc;
        }, {});

        // Get campaign names from matched IDs
        const matchedCampaignNames = campaignIds.map(
          (id) => campaignMapping[id] || 'Unknown Campaign'
        );

        // Get tag names from matched IDs (flattened)
        const matchedTagNames = tagIds.map((id) => tagMapping[id] || '(Blanks)').flat();

        console.log('Matched Campaign Names:', matchedCampaignNames);
        console.log('Matched Tag Names:', matchedTagNames);

        // Update contacts with campaignName and tags
        const updatedContacts = gridData.leads.map((lead) => ({
          ...lead,
          campaignName: matchedCampaignNames, // Correct format
          tags: matchedTagNames, // Flattened array
        }));

        // Update grid data
        const updatedGridData = {
          ...gridData,
          leads: updatedContacts,
        };
        console.log('🚀 ~ useEffect ~ updatedGridData:', updatedGridData);

        // Update the grid with new data
        gridRef.current.api.setGridOption('rowData', updatedGridData.leads);
        gridRef.current.api.refreshCells();
      } catch (error) {
        console.error('Error parsing filterJson:', error);
      }
    }
  }, [gridData, campaignListDropdown, tagsList]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    setpaginationLoading(leadPageLoader);
  }, [leadPageLoader]);

  useEffect(() => {
    const plannedOption = memberStatus?.find((option) => option.displayName === 'Planned');

    if (plannedOption) {
      setSelectedOptions((prevState) => ({
        ...prevState,
        memberStatusId: plannedOption.id,
      }));

      setcampaignData((prevState) => ({
        ...prevState,
        memberStatus: plannedOption.id,
        memberStatusId: plannedOption.displayName,
      }));
    }
  }, [memberStatus]);

  useEffect(() => {
    // Check if userInfo exists and if the owner field hasn't been set yet.
    if (userInfo && userInfo?.user?.userId && !formData.owner) {
      // Update formData with the userInfo.userId.
      setFormData((prevData) => ({
        ...prevData,
        owner: userInfo?.user?.display_name,
        ownerId: userInfo?.user?.userId,
      }));
    }
  }, [remindVisible]);

  useEffect(() => {
    if (!formData?.reminder) {
      setShowReminderPage(false);
      setFormData((prev) => ({
        ...prev,
        showReminder: false,
      }));
    }
  }, [formData?.reminder]);

  // Restore selection on rowData change
  useEffect(() => {
    const gridApi = gridParams?.api;
    if (!gridApi || !gridData?.inputPayload?.pageNumber) return;

    const pageKey = 'page-' + gridData.inputPayload.pageNumber;
    const selectedRowsDefault = gridDataSelection?.leads?.[pageKey] || [];

    if (selectedRowsDefault.length > 0) {
      gridApi.forEachNode((node) => {
        const isSelected = selectedRowsDefault.some((row) => row.id === node.data?.id);
        node.setSelected(isSelected);
      });
    } else {
      gridApi.deselectAll(); // Optional: clear selection
    }
  }, [gridParams, rowData, location.pathname]);

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                {fullSelection.length > 0 ? (
                  <div className="main-hd">
                    <div className="left_lead">
                      {hasUpdateLeadPermission && (
                        <>
                          <div className="heading_item topLink" id="createtask_dropdown">
                            <Link
                              href="#"
                              className="task_btn hd-btn"
                              onClick={togglePopupVisibility}
                            >
                              {' '}
                              <img
                                src={ticket}
                                alt="Create Ticket"
                                className="me-2"
                                style={{ width: '14px', height: '14px' }}
                              />
                              <span className="btnText"> Create Ticket</span>
                            </Link>
                          </div>
                          <div className="heading_item topLink" id="tags_dropdown">
                            <div className="dropdown">
                              <button
                                className=" btn action-btn dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                Tags
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <li>
                                  <Link className="dropdown-item" onClick={handleAddTag}>
                                    Add Tags
                                  </Link>
                                </li>
                                <li>
                                  <Link className="dropdown-item" onClick={handleRemoveTag}>
                                    Remove Tags
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="heading_item topLink" id="actiongrid_dropdown">
                        <div className="dropdown">
                          <button
                            className="btn action-btn dropdown-toggle "
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Actions
                          </button>

                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {hasUpdateLeadPermission && (
                              <li
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#myModal"
                                onClick={() => handleGetMassPopup()}
                              >
                                Mass Update
                              </li>
                            )}
                            {hasUpdateLeadPermission && (
                              <li
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#myOwner"
                                onClick={() => handleGetMassPopup()}
                              >
                                Change Owner
                              </li>
                            )}
                            {hasUpdateLeadPermission && (
                              <li className="dropdown-submenu">
                                <a
                                  className="dropdown-item "
                                  id="addToCampaignsDropdown"
                                  aria-expanded="false"
                                >
                                  Add To Campaigns
                                  <span className="right-arrow"></span>
                                </a>
                                <ul className="dropdown-menu submenu ">
                                  <li
                                    className="dropdown-item"
                                    onClick={handleOpenExistingCampaignPopup}
                                  >
                                    Existing
                                  </li>
                                  <li className="dropdown-item disabled">
                                    Create New(Coming Soon)
                                  </li>
                                </ul>
                              </li>
                            )}
                            {hasDeleteLeadPermission && (
                              <li
                                className="dropdown-item"
                                data-bs-toggle="modal"
                                data-bs-target="#delete"
                              >
                                Delete
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="third-div dsk">
                      <div className="heading_item ">
                        <div className="dsk">
                          <GlobalSearch moduleName={'leads'} fullSelection={fullSelection} />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="main-hd tabP">
                    <div className="mob">
                      <div className="pagetitle">
                        <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                        {isTabActive === 'myLeads' ? 'My Leads' : isTabActive === 'allLeads' ? 'All Leads' : isTabActive === 'teams' ? 'Teams' : 'Buckets'}
                      </div>
                    </div>
                    <div className="dsk">
                      <div className="pagetitle tabLeft">
                        <div className="nav nav-tabs">
                          <button
                            className={`nav-link ${isTabActive === 'myLeads' ? 'active' : ''}`}
                            type="button"
                            onClick={() => setIsTabActive('myLeads')}
                          >
                            My Leads
                          </button>
                          <button
                            className={`nav-link ${isTabActive === 'allLeads' ? 'active' : ''}`}
                            type="button"
                            onClick={() => setIsTabActive('allLeads')}
                          >
                            All Leads
                          </button>
                          <button
                            className={`nav-link ${isTabActive === 'teams' ? 'active' : ''}`}
                            type="button"
                            onClick={() => setIsTabActive('teams')}
                          >
                            Teams
                          </button>
                          <button
                            className={`nav-link ${isTabActive === 'buckets' ? 'active' : ''}`}
                            type="button"
                            onClick={() => setIsTabActive('buckets')}
                          >
                            Buckets
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="third-div mobView tabAction">
                      <div className="dsk">
                        <GlobalSearch moduleName={'leads'} fullSelection={fullSelection} />
                      </div>

                      <div className="heading_item" id="actiongrid_dropdown">
                        <div className="dropdown">
                          <button
                            className="btn action-btn mobOption dropdown-toggle "
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className="mob">
                              <i className="bi bi-three-dots"></i>
                            </div>{' '}
                            <div className="dsk">Options</div>
                          </button>

                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li className="dropdown-item" onClick={handleOpenManageTag}>
                              Manage Tags
                            </li>
                            <li className="dropdown-item" onClick={handleOpenMassEmail}>
                              Mass Email
                            </li>
                            <li className="dropdown-item" onClick={exportAll}>
                              Export Leads
                            </li>
                          </ul>
                        </div>
                      </div>
                      {hasCreateLeadPermission && (
                        <div className="btn-group" id="timelogdropdown">
                          <button type="button" className="timelog-btn" onClick={handleOpenAddForm}>
                            Create Lead
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li className="dropdown-item">
                              <Link to="/leads/importLead">Import Leads</Link>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="mob mb-3 tabMob">
                  <div className="nav nav-tabs">
                    <button
                      className={`nav-link ${isTabActive === 'myLeads' ? 'active' : ''}`}
                      type="button"
                      onClick={() => setIsTabActive('myLeads')}
                    >
                      My Leads
                    </button>
                    <button
                      className={`nav-link ${isTabActive === 'allLeads' ? 'active' : ''}`}
                      type="button"
                      onClick={() => setIsTabActive('allLeads')}
                    >
                      All Leads
                    </button>
                    <button
                      className={`nav-link ${isTabActive === 'teams' ? 'active' : ''}`}
                      type="button"
                      onClick={() => setIsTabActive('teams')}
                    >
                      Teams
                    </button>
                    <button
                      className={`nav-link ${isTabActive === 'buckets' ? 'active' : ''}`}
                      type="button"
                      onClick={() => setIsTabActive('buckets')}
                    >
                      Buckets
                    </button>
                  </div>
                </div>
                <div className="mob mb-3">
                  <GlobalSearch moduleName={'leads'} />
                </div>
                <div className="tabPage">
                  <div className="tab-content">
                    {isTabActive === 'myLeads' ? (
                      <div />
                    ) : isTabActive === 'allLeads' ? (
                      <div className="cutome_ag_theme">
                        {loading && <Loader />}
                        <div
                          className={`ag-theme-${selectedTheme} tbl_height`}
                          style={{ width: '100%', height: `100%` }}
                        >
                          {gridLoading ? (
                            <CustomLoadingOverlay loadingMessage="Loading..." />
                          ) : (
                            <AgGridReact
                              className="ag-grid-container"
                              domLayout="fixedHeight"
                              ref={gridRef}
                              rowData={rowData}
                              columnDefs={columnDefs}
                              autoGroupColumnDef={autoGroupColumnDef}
                              defaultColDef={defaultColDef}
                              overlayLoadingTemplate={`<Loader />`}
                              animateRows={true}
                              rowSelection={'multiple'}
                              sideBar={sideBar}
                              enableRangeSelection={true}
                              suppressExcelExport={true}
                              suppressRowClickSelection={true}
                              groupSelectsChildren={true}
                              enableRowGroup={true}
                              popupParent={popupParent}
                              sortingOrder={sortingOrder}
                              onFirstDataRendered={onFirstDataRendered}
                              onCellClicked={cellClickedListener}
                              suppressMoveWhenRowDragging={true}
                              gridOptions={gridOptions}
                              columnTypes={columnTypes}
                              onSelectionChanged={onSelectionChanged}
                              rowGroupPanelShow={'always'}
                              suppressScrollOnNewData={true}
                              alwaysShowVerticalScroll={true}
                              onFilterChanged={handleFilterChanged}
                              onSortChanged={handleSortChanged}
                              onGridReady={handleGridReady}
                              onColumnMoved={handleColumnChanged}
                              onColumnVisible={handleColumnChanged}
                            />
                          )}
                          {gridParams && (
                            <FilterHandler
                              params={gridParams}
                              gridData={gridData}
                              campaignListDropdown={campaignListDropdown}
                              tagsList={tagsList}
                              columnDefs={columnDefs}
                              filterDefaultSetRef={filterDefaultSetRef}
                            />
                          )}
                        </div>
                      </div>
                    ) : isTabActive === 'teams' ? (
                      <div className="cutome_ag_theme" style={{ padding: '20px' }}>
                        <div style={{ width: '200px' }}>
                          <Select
                            placeholder="Select Team"
                            value={selectedTeam}
                            onChange={(opt) => setSelectedTeam(opt)}
                            options={[
                              { value: 'team1', label: 'Team 1' },
                              { value: 'team2', label: 'Team 2' },
                            ]}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="cutome_ag_theme" style={{ padding: '20px' }}>
                        <div style={{ width: '200px' }}>
                          <Select
                            placeholder="Select Bucket"
                            value={selectedBucket}
                            onChange={(opt) => setSelectedBucket(opt)}
                            options={[
                              { value: 'bucket1', label: 'Bucket 1' },
                              { value: 'bucket2', label: 'Bucket 2' },
                            ]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`email-popup ${isOpen ? 'open' : ''} ${isMinimized ? 'minimized' : ''}`}>
            <div className="popup-header border_btm email_hd">
              <h5>New Message</h5>
              <div className="modal_btn_group">
                <button onClick={toggleMinimize} className="minimize-btn">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="25"
                      height="25"
                      rx="5.5"
                      fill="white"
                      stroke="#9B9B9B"
                    />
                    <line x1="8" y1="18" x2="19" y2="18" stroke="#9B9B9B" strokeWidth="2" />
                  </svg>
                </button>
                <button className="maxmin-btn">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="25"
                      height="25"
                      rx="5.5"
                      fill="white"
                      stroke="#9B9B9B"
                    />
                    <path
                      d="M13.7222 12.2778L18 8M18 8H14.3333M18 8V11.6667M11.2778 14.7222L7 19M7 19H10.6667M7 19V15.3333"
                      stroke="#9B9B9B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                <button onClick={emailPopup} className="close-btn">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="25"
                      height="25"
                      rx="5.5"
                      fill="white"
                      stroke="#9B9B9B"
                    />
                    <path
                      d="M16.2989 17.6905L13.0093 14.3961L9.7198 17.6905C9.62799 17.7869 9.51786 17.8639 9.39589 17.917C9.27392 17.9702 9.14257 17.9984 9.00957 17.9999C8.87656 18.0015 8.74459 17.9764 8.6214 17.9262C8.49822 17.8759 8.38631 17.8015 8.29225 17.7073C8.1982 17.6131 8.1239 17.5011 8.07372 17.3777C8.02354 17.2543 7.9985 17.1222 8.00007 16.989C8.00164 16.8558 8.02978 16.7242 8.08284 16.6021C8.13591 16.4799 8.21283 16.3696 8.30907 16.2777L11.5986 12.9834L8.30907 9.68902C8.12921 9.50021 8.03024 9.24843 8.03331 8.9875C8.03638 8.72657 8.14125 8.4772 8.32549 8.29268C8.50974 8.10816 8.75875 8.00314 9.0193 8.00007C9.27985 7.997 9.53126 8.09611 9.7198 8.27623L13.0093 11.5706L16.2989 8.27623C16.4874 8.09611 16.7388 7.997 16.9994 8.00007C17.2599 8.00314 17.5089 8.10816 17.6932 8.29268C17.8774 8.4772 17.9823 8.72657 17.9854 8.9875C17.9884 9.24843 17.8895 9.50021 17.7096 9.68902L14.4201 12.9834L17.7096 16.2777C17.8956 16.4656 18 16.7195 18 16.9841C18 17.2487 17.8956 17.5026 17.7096 17.6905C17.6173 17.7839 17.5074 17.8581 17.3862 17.9086C17.265 17.9591 17.135 17.985 17.0037 17.9848C16.8725 17.9846 16.7426 17.9582 16.6216 17.9073C16.5006 17.8563 16.3909 17.7818 16.2989 17.688V17.6905Z"
                      fill="#9B9B9B"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="popup-body email_body">
              <div className="container_label border_btm">
                <div className="label_nm">
                  gfyuoui
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1668 20.125V18.2083C19.1668 17.1917 18.763 16.2166 18.0441 15.4978C17.3252 14.7789 16.3502 14.375 15.3335 14.375H7.66683C6.65017 14.375 5.67514 14.7789 4.95625 15.4978C4.23736 16.2166 3.8335 17.1917 3.8335 18.2083V20.125M15.3335 6.70833C15.3335 8.82542 13.6173 10.5417 11.5002 10.5417C9.38307 10.5417 7.66683 8.82542 7.66683 6.70833C7.66683 4.59124 9.38307 2.875 11.5002 2.875C13.6173 2.875 15.3335 4.59124 15.3335 6.70833Z"
                      stroke="#9B9B9B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <div className="label_content">
                    <label htmlFor="email">
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '.8rem',
                        }}
                      >
                        John Doe
                      </span>{' '}
                      <span
                        style={{
                          color: '#666',
                          fontSize: '.8rem',
                        }}
                      >
                        &lt;johndoetest@nomail.com&gt;
                      </span>
                    </label>
                  </div>
                </div>
                <div className="heading_item" id="insert_template">
                  <div className="dropdown">
                    <button
                      className=" btn action-btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Insert Template
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <li>
                        <Link className="dropdown-item" href="#">
                          Add Template
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="container_label border_btm">
                <div className="label_nm">
                  <span> To :</span>

                  <div className="label_content">
                    <div>
                      <Select
                        isMulti
                        value={selectedOptions}
                        onChange={setSelectedOptions}
                        placeholder="Select options..."
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="container_label border_btm">
                <div className="label_nm">
                  <span>Subject :</span>

                  <div className="label_content">
                    <div>
                      <Select
                        isMulti
                        value={selectedOptions}
                        onChange={setSelectedOptions}
                        placeholder="Select options..."
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-footer">
              <div className="email_group">
                <OverlayTrigger
                  trigger="click"
                  placement="top"
                  rootClose={true}
                  show={popupVisible}
                  onToggle={() => setPopupVisible(!popupVisible)}
                  overlay={
                    <Popover id="popover-basic">
                      <Popover.Body>
                        <div className="showcontent" id="textinputview">
                          <p>
                            <span>On</span> <input type="date" /> <span>at</span>{' '}
                            <input type="time" />
                          </p>
                        </div>

                        <div className="rightAction popupspacing">
                          <button type="button" className="btn btn-outline-primary">
                            Cancel
                          </button>
                          <button type="button" className="btn btn-primary">
                            Done
                          </button>
                        </div>
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <div
                    className="schedule-btn"
                    type="button"
                    onClick={() => setPopupVisible(!popupVisible)}
                  >
                    <img src={schedule} alt="schedule" />
                    Schedule
                  </div>
                </OverlayTrigger>
                <button className="add-btn" type="button">
                  Send
                </button>
              </div>
            </div>
          </div>

          {showMassEmailPopup && (
            <MassEmail
              handleClose={closeMassEmailPopup}
              selectedRows={fullSelection}
              module={'Lead'}
            />
          )}
        </div>

        <ChildTicket
          remindVisible={remindVisible}
          showReminderPage={showReminderPage}
          handleBackClick={handleBackClick}
          togglePopupVisibility={togglePopupVisibility}
          formData={formData}
          handleDateTime={handleDateTime}
          handleChangeForm={handleChangeForm}
          errormsg={errormsg}
          handleChange={handleChange}
          selectedOptions={selectedOptions}
          ticketPriorityDropdown={ticketPriorityDropdown}
          owner={owner}
          ticketStatusDropdown={ticketStatusDropdown}
          handleReminderClick={handleReminderClick}
          loading={loading}
          handleFormSubmit={handleFormSubmit}
        />
        {/* Modal structure Mass Update */}
        <div id="dropdown_modal">
          <div
            className="modal fade"
            id="myModal"
            tabIndex="-1"
            aria-labelledby="modalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content" style={{ minWidth: '640px' }}>
                <div className="modal-header">
                  <h5 className="modal-title" id="modalLabel">
                    Mass Update
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="input-container">
                        <>
                          <label htmlFor="timeZoneId">Field</label>
                          <Select
                            value={isSelectedOption ? selectedOption : null}
                            options={allcolumnList?.map((data) => ({
                              value: data.field,
                              label: data.headerName,
                              originalData: data,
                            }))}
                            onChange={(selectedOption) => handleSelection(selectedOption)}
                            menuShouldScrollIntoView={false}
                            disabled={'timeZoneId'}
                            placeholder={'Select Field'}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                borderColor: state.isFocused ? '#365397' : base.borderColor,
                                borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                boxShadow: state.isFocused
                                  ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                  : 'none',
                                transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                  borderColor: '#365397',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: '5px',
                                zIndex: 99999,
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : state.isFocused
                                    ? '#DEEBFF'
                                    : base.backgroundColor,
                                color: state.isSelected
                                  ? '#222'
                                  : state.isFocused
                                    ? '#222'
                                    : base.color,
                                cursor: 'pointer',
                              }),
                            }}
                            menuPortalTarget={document.body}
                          />
                        </>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="input-container massInput">
                        {selectedOption && isSelectedOption ? (
                          selectedOption.originalData.type === 'text' ? (
                            <input
                              type="text"
                              placeholder={`Enter ${selectedOption.label}`}
                              value={fieldValues[selectedOption.value] || ''}
                              onChange={(e) => handleInputChange(e, selectedOption.value)}
                              style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '5px',
                                border: '1px solid #ccc', // Matches Select border color
                                padding: '8px 12px', // Matches Select padding
                                marginTop: '14px',
                                fontSize: '16px',
                                outline: 'none',
                                transition: 'border-color 0.3s, box-shadow 0.3s',
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#365397'; // Focus border color
                                e.target.style.boxShadow = '0 0 5px rgba(0, 86, 179, 0.3)'; // Focus box-shadow
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#ccc'; // Reset border color on blur
                                e.target.style.boxShadow = 'none'; // Remove box-shadow on blur
                              }}
                            />
                          ) : selectedOption.originalData.type === 'dropdown' ? (
                            <Select
                              value={
                                fieldValues[`${selectedOption?.value}Id`] // Check if there's a value in the state for the selected option
                                  ? {
                                    value: fieldValues[`${selectedOption?.value}Id`],
                                    label:
                                      selectedOption.originalData.data?.find(
                                        (data) =>
                                          data.id === fieldValues[`${selectedOption?.value}Id`] ||
                                          (data.userId &&
                                            data.userId ===
                                            fieldValues[`${selectedOption?.value}Id`]) // Check both `id` and `userId` properly
                                      )?.displayName ||
                                      selectedOption.originalData.data?.find(
                                        (data) =>
                                          data.id === fieldValues[`${selectedOption?.value}Id`] ||
                                          (data.userId &&
                                            data.userId ===
                                            fieldValues[`${selectedOption?.value}Id`])
                                      )?.display_name ||
                                      '',
                                  }
                                  : null // If no value, set null to reset
                              }
                              options={
                                selectedOption.originalData.data?.map((data) => ({
                                  value: data.id ? data.id : data.userId,
                                  label: data.displayName ? data.displayName : data.display_name,
                                })) || []
                              }
                              disabled
                              placeholder={`Select ${selectedOption.label}`}
                              menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                  boxShadow: state.isFocused
                                    ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                    : 'none',
                                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#365397',
                                  },
                                }),

                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                              onChange={(selected) =>
                                handleDropdownChange(selected, `${selectedOption.value}Id`)
                              }
                            />
                          ) : selectedOption.originalData.type === 'number' ? (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '14px',
                                position: 'relative',
                              }}
                            >
                              {/* Input wrapper with relative position */}
                              {selectedOption.originalData.headerName === 'Annual Revenue' && (
                                <div
                                  style={{
                                    position: 'relative',
                                    width: '100%',
                                  }}
                                >
                                  {/* Dollar symbol inside the input box */}
                                  <span
                                    style={{
                                      position: 'absolute',
                                      left: '10px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      fontSize: '16px',
                                      color: '#888',
                                      pointerEvents: 'none',
                                    }}
                                  >
                                    $
                                  </span>
                                  <input
                                    type="number"
                                    placeholder={`Enter ${selectedOption.label}`}
                                    value={fieldValues[selectedOption.value] || ''}
                                    onChange={(e) => {
                                      // Enforce number limit conditionally for "Mobile"
                                      const value = e.target.value;
                                      if (
                                        selectedOption.originalData.headerName === 'Mobile' &&
                                        value.length > 15
                                      ) {
                                        return; // Prevent further input if length exceeds limit
                                      }
                                      handleInputChange(e, selectedOption.value); // Call your change handler
                                    }}
                                    style={{
                                      width: '100%',
                                      height: '40px',
                                      borderRadius: '5px',
                                      border: '1px solid #ccc',
                                      padding: '8px 12px 8px 30px', // Add padding-left to account for the dollar symbol
                                      fontSize: '16px',
                                      outline: 'none',
                                      transition: 'border-color 0.3s, box-shadow 0.3s',
                                    }}
                                    onFocus={(e) => {
                                      e.target.style.borderColor = '#365397';
                                      e.target.style.boxShadow = '0 0 0 1px #365397';
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.borderColor = '#ccc';
                                      e.target.style.boxShadow = 'none';
                                    }}
                                  />
                                </div>
                              )}
                              {/* Input without the dollar sign for other cases */}
                              {selectedOption.originalData.headerName !== 'Annual Revenue' && (
                                <input
                                  type="number"
                                  placeholder={`Enter ${selectedOption.label}`}
                                  value={fieldValues[selectedOption.value] || ''}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (
                                      selectedOption.originalData.headerName === 'Mobile' &&
                                      value.length > 15
                                    ) {
                                      return;
                                    }
                                    handleInputChange(e, selectedOption.value);
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    padding: '8px 12px',
                                    fontSize: '16px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#365397';
                                    e.target.style.boxShadow = '0 0 0 1px #365397';
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#ccc';
                                    e.target.style.boxShadow = 'none';
                                  }}
                                />
                              )}
                            </div>
                          ) : selectedOption.originalData.type === 'checkbox' ? (
                            <div className="input-container" id="flex-clumn">
                              <span>Email Opt Out</span>
                              <input
                                type="checkbox"
                                label={'Email Opt Out'}
                                name={'emailOptOut'}
                                onChange={handleChangeCheckbox}
                              />
                            </div>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancel_popup"
                    id="massUpdateCancel"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="save_popup"
                    onClick={() => handleMassUpdate(fullSelection)}
                    disabled={loading}
                  >
                    Submit
                    {loading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal structure Change Owner */}
        <div id="dropdown_modal">
          <div
            className="modal fade"
            id="myOwner"
            tabIndex="-1"
            aria-labelledby="modalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="modalLabel">
                    Change Owner
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12 col-md-12" id="ownermodal">
                      <div className="input-container">
                        <label htmlFor="timeZoneId">Leads Owner</label>
                        <Select
                          // value={owner
                          //   ?.map((data) => ({
                          //     value: data.userId,
                          //     label: data.display_name,
                          //   }))
                          //   .find((option) => option.value === ownerFieldValues.ownerId) || null}
                          options={owner?.map((data) => ({
                            value: data.userId,
                            label: data.display_name,
                          }))}
                          menuShouldScrollIntoView={false}
                          placeholder={'Select Owner'}
                          onChange={handleSelectChange}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderRadius: '5px',
                              borderColor: state.isFocused ? '#365397' : base.borderColor,
                              borderWidth: state.isFocused ? '1px' : base.borderWidth,
                              boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
                              transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                              '&:hover': {
                                borderColor: '#365397',
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: '5px',
                              zIndex: 99999,
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? '#DEEBFF'
                                : state.isFocused
                                  ? '#DEEBFF'
                                  : base.backgroundColor,
                              color: state.isSelected
                                ? '#222'
                                : state.isFocused
                                  ? '#222'
                                  : base.color,
                              cursor: 'pointer',
                            }),
                          }}
                          menuPortalTarget={document.body}
                          components={{
                            DropdownIndicator: (props) => (
                              <div
                                {...props.innerProps}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <svg
                                  width="18"
                                  height="20"
                                  viewBox="0 0 18 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                                    stroke="#9B9B9B"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-end">
                  <button
                    type="button"
                    className="cancel_popup"
                    data-bs-dismiss="modal"
                    id="ownerUpdateCancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="save_popup "
                    onClick={() => handleOwnerUpdate(fullSelection)}
                    disabled={loading}
                  >
                    {loading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    Change Owner
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Modal structure Add To Campaigns */}
        {showExistingCampaignPopup && (
          <div id="dropdown_modal">
            <div
              className={`modal ${showExistingCampaignPopup ? 'd-block show' : 'd-none'}`}
              tabIndex="-1"
              aria-labelledby="modalLabel"
              aria-hidden={!showExistingCampaignPopup}
              style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            >
              <div className="modal-dialog ">
                <div className="modal-content" style={{ 'min-width': '600px' }}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="modalLabel">
                      Add to Campaigns
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      // data-bs-dismiss="modal"
                      // aria-label="Close"
                      // id="closeModalButton"
                      onClick={handleCloseExistingCampaignPopup}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-12 col-md-6" id="myexisting">
                        <div className="input-container">
                          <SelectBox
                            label={'Assign Campaign'}
                            name={'campaignId'}
                            placeholder={'Campaign Source'}
                            // isRequired={true}
                            selectedOptions={selectedOptions?.campaignId}
                            handleSelect={handleChange}
                            options={campaignList}
                            optionKeys={['id', 'campaignName']}
                            errormsg={errormsg?.campaignId}
                            isLoading={isCampaignLoading}
                            onSearch={handleCampaignSearch}
                            onScrollToBottom={handleCampaignScroll}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                borderColor: state.isFocused ? '#365397' : base.borderColor,
                                borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                boxShadow: state.isFocused
                                  ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                  : 'none',
                                transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                  borderColor: '#365397',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: '5px',
                                zIndex: 99999,
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : state.isFocused
                                    ? '#DEEBFF'
                                    : base.backgroundColor,
                                color: state.isSelected
                                  ? '#222'
                                  : state.isFocused
                                    ? '#222'
                                    : base.color,
                                cursor: 'pointer',
                              }),
                            }}
                            menuPortalTarget={document.body}
                            components={{
                              DropdownIndicator: (props) => (
                                <div
                                  {...props.innerProps}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <svg
                                    width="20"
                                    height="16"
                                    viewBox="0 0 20 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M0.694444 3.83398C0.310926 3.83398 0 4.12572 0 4.48556V9.5713C0 9.93114 0.310926 10.2229 0.694444 10.2229C1.07796 10.2229 1.38889 9.93114 1.38889 9.5713V4.48556C1.38889 4.12572 1.07796 3.83398 0.694444 3.83398Z"
                                      fill="#9B9B9B"
                                    />
                                    <path
                                      d="M14.0917 0.222656H11.4687C11.1205 0.222656 10.8382 0.504721 10.8382 0.85264V1.42173L2.39558 3.92343C2.12793 4.00273 1.94434 4.2485 1.94434 4.52738V9.44226C1.94417 9.47375 1.9472 9.50551 1.95191 9.53734C1.95275 9.54322 1.95359 9.5491 1.9546 9.5549C1.95931 9.58094 1.96502 9.60698 1.97318 9.63285L3.7604 15.3363C3.84479 15.6057 4.09353 15.7782 4.36185 15.7782C4.42414 15.7782 4.48752 15.7689 4.55015 15.7493L7.15276 14.9361C7.31239 14.8862 7.44563 14.775 7.52313 14.627C7.60072 14.479 7.61619 14.3062 7.56626 14.1467L6.68059 11.3186L10.8382 12.5508V13.1198C10.8382 13.4678 11.1204 13.7498 11.4686 13.7498H14.0917C14.4398 13.7498 14.7221 13.4678 14.7221 13.1198V0.85264C14.7222 0.504721 14.4399 0.222656 14.0917 0.222656ZM6.17463 13.9216L4.77535 14.3588L3.53007 10.3848L5.22423 10.8869L6.17463 13.9216ZM5.90841 9.77556C5.90664 9.77506 5.90479 9.77447 5.90303 9.77396L3.20534 8.97439V4.99768L10.8383 2.73595V11.2367L5.90841 9.77556ZM13.4613 12.4899H12.0992V12.0806V1.89203V1.48271H13.4613V12.4899Z"
                                      fill="#9B9B9B"
                                    />
                                    <path
                                      d="M19.0799 10.4739L16.2306 9.17481C15.9052 9.02664 15.5097 9.14663 15.347 9.44328C15.1843 9.73985 15.3162 10.1005 15.6415 10.2488L18.4908 11.5479C18.5854 11.591 18.6858 11.6113 18.7849 11.6113C19.0264 11.6113 19.259 11.4897 19.3744 11.2794C19.537 10.9828 19.4051 10.6222 19.0799 10.4739Z"
                                      fill="#9B9B9B"
                                    />
                                    <path
                                      d="M15.9365 4.94575C16.0355 4.94575 16.136 4.92307 16.2305 4.87513L19.0798 3.43184C19.4051 3.26702 19.537 2.86642 19.3743 2.53688C19.2117 2.20735 18.8161 2.07375 18.4909 2.23857L15.6415 3.68186C15.3162 3.84667 15.1843 4.24727 15.347 4.57681C15.4624 4.81064 15.695 4.94575 15.9365 4.94575Z"
                                      fill="#9B9B9B"
                                    />
                                    <path
                                      d="M19.3564 6.33398H17.032C16.6767 6.33398 16.3887 6.64491 16.3887 7.02843C16.3887 7.41195 16.6767 7.72287 17.032 7.72287H19.3564C19.7117 7.72287 19.9998 7.41195 19.9998 7.02843C19.9998 6.64482 19.7117 6.33398 19.3564 6.33398Z"
                                      fill="#9B9B9B"
                                    />
                                  </svg>
                                </div>
                              ),
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="input-container">
                          <>
                            <label htmlFor="timeZoneId">Select Member Status</label>
                            <Select
                              value={selectedOptions?.memberStatus}
                              placeholder={campaignData?.memberStatusId}
                              onChange={(selectedOption) =>
                                handleChange(selectedOption, 'memberStatusId')
                              }
                              options={memberStatus?.map((data) => ({
                                value: data.id,
                                label: data.displayName,
                              }))}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                  boxShadow: state.isFocused
                                    ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                    : 'none',
                                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                  '&:hover': {
                                    borderColor: '#365397',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : state.isFocused
                                      ? '#DEEBFF'
                                      : base.backgroundColor,
                                  color: state.isSelected
                                    ? '#222'
                                    : state.isFocused
                                      ? '#222'
                                      : base.color,
                                  cursor: 'pointer',
                                }),
                              }}
                              menuPortalTarget={document.body}
                            />
                            {/* {errormsg.timeZoneId && (
                                  <div className="error-message">
                                    {errormsg.timeZoneId}
                                  </div>
                                )} */}
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-end">
                    <button
                      type="button"
                      className="cancel_popup"
                      // data-bs-dismiss="modal"
                      onClick={handleCloseExistingCampaignPopup}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="save_popup"
                      onClick={() => handleSubmit(campaignData)}
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Modal structure Delete */}
        <div id="dropdown_modal">
          <div
            className="modal fade"
            id="delete"
            tabIndex="-1"
            aria-labelledby="modalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="warning-content">
                  <div className="warningOuter">
                    <div className="alertImg">
                      <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
                    </div>
                    <div className="warningText">
                      Are you sure you want to delete the selected record?
                    </div>
                  </div>{' '}
                  <div className="notes">
                    *Note: Any associated Activities, Visits, Drafts will also be Deleted.
                  </div>
                  <div className="warningBtn mt-2">
                    <Button
                      id="massDeleteModal"
                      variant="secondary"
                      className="btn"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Button>
                    <Button className="btn" variant="danger" onClick={handleClickDelete}>
                      Confirm Delete
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Popup Modal */}
        {showPopup && (
          <div id="genricPopup">
            <div className="popup-overlay">
              <div className="popup">
                <div className="popup-header">
                  <h2>{popupAction === 'add' ? 'Add Tags' : 'Remove Tags'}</h2>
                  <button
                    type="button"
                    className="custom-btn-close"
                    aria-label="Close"
                    onClick={togglePopup}
                  ></button>
                </div>
                {popupAction === 'add' ? (
                  <Tags
                    module="Lead"
                    handleClose={togglePopup}
                    selectedRows={fullSelection}
                    View={false}
                    storeKey={'leads'}
                  />
                ) : (
                  <Tags
                    module="Lead"
                    removeMode={true}
                    handleClose={togglePopup}
                    selectedRows={fullSelection}
                    View={false}
                    storeKey={'leads'}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Leads;
